<div>
  <button mat-button type="button" color="primary" (click)="addState()" i18n>Add state</button>

  <div *ngFor="let state of states; let i = index">
    <mat-card appearance="outlined">
      {{ state.name }}<ng-container *ngIf="state.initial" i18n> - initial</ng-container>
      <button mat-button type="button" color="primary" (click)="editState(i)" i18n>Edit</button>
      <button mat-button type="button" color="warn" (click)="removeState(i)" i18n>Remove</button>
    </mat-card>
  </div>
</div>
